import { FormControl, FormGroup, Validators, } from '@angular/forms';
import { ConfigurationEntryValueType, } from '@models';
import * as i0 from "@angular/core";
var DynamicConfigurationFormService = /** @class */ (function () {
    function DynamicConfigurationFormService() {
    }
    DynamicConfigurationFormService.prototype.toFormGroup = function (configurationEntries, data) {
        var _this = this;
        var group = {};
        configurationEntries.forEach(function (configurationEntry) {
            if (configurationEntry.valueType === ConfigurationEntryValueType.Section) {
                var subValue = data ? data[configurationEntry.key] : data;
                group[configurationEntry.key] = _this.toFormGroup(configurationEntry.configurations, subValue);
            }
            else {
                var value = data && data[configurationEntry.key] || configurationEntry.defaultValue;
                var validators = [];
                if (configurationEntry.isMandatory) {
                    validators.push(Validators.required);
                }
                group[configurationEntry.key] = new FormControl(value, validators);
            }
        });
        return new FormGroup(group);
    };
    DynamicConfigurationFormService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DynamicConfigurationFormService_Factory() { return new DynamicConfigurationFormService(); }, token: DynamicConfigurationFormService, providedIn: "root" });
    return DynamicConfigurationFormService;
}());
export { DynamicConfigurationFormService };
